import { SortTopIcon, SortBottomIcon } from "@/components/common/svgs";
import { cn } from "@/utils/css";

export const SortableTableHead = ({ children, sortKey, currentSort = { key: null, direction: null }, onSort, className, ...props }) => {
    const isSorted = currentSort?.key === sortKey;
    const isAscending = currentSort?.direction === "asc";

    const handleClick = () => {
        if (onSort && sortKey) {
            if (isSorted) {
                onSort(sortKey, isAscending ? "desc" : "asc");
            } else {
                onSort(sortKey, "desc");
            }
        }
    };

    return (
        <th
            className={cn("text-sm/[22px] text-cm-p-text-primary font-medium text-left cursor-pointer transition-colors", className)}
            onClick={handleClick}
            {...props}
        >
            <div className="px-2 py-3 flex items-center gap-[2px]">
                <div>{children}</div>

                {onSort && sortKey && (
                    <div className="flex flex-col gap-[2px] items-center justify-center w-6 h-6">
                        <SortTopIcon active={isSorted && isAscending} />
                        <SortBottomIcon active={isSorted && !isAscending} />
                    </div>
                )}
            </div>
        </th>
    );
};
